export const menuStyles = {
  menu: {
    marginTop: "-1px",
    paddingLeft: 0,
    width: "auto",
    "@media (minWidth: 1024px)": {
      paddingLeft: "20px",
      width: "350px"
    }
  },
  flexColumnWrapper: {
    display: "flex",
    flexDirection: "column"
  },
  flexRowWrapper: {
    display: "flex",
    flexDirection: "row"
  },
  topContainer: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "1px solid #ddd"
  },
  mobileTopContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderBottom: "1px solid #ddd",
    justifyContent: "space-between",
    cursor: "pointer"
  },
  mobileMenuIcon: {
    position: "relative",
    top: -6,
    width: 30,
    height: 5,
    backgroundColor: "#808080",
    boxShadow: "0 9px 0 0 #808080, 0 18px 0 0 #808080",
    marginRight: "20px"
  },
  contentContainer: {
    display: "flex",
    flexDirection: "row"
  },
  content: {
    width: "90%"
  },
  logo: {
    marginLeft: 10
  },
  menuItem: {
    cursor: "pointer",
    fontSize: "14px",
    display: "block",
    lineHeight: "1.5",
    margin: 0,
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    borderBottom: "1px solid #999",
    textAlign: "left",
    textDecoration: "none",
    fontFamily: "Helvetica, Arial, sans-serif",
    color: "#fff",
    fontWeight: "bold",
    backgroundColor: "#444",
    width: "100%",
    padding: "10px 20px",
    ":hover": {
      backgroundColor: "#555",
      textDecoration: "underline"
    },
    "@media (minWidth: 1024px)": {
      width: "220px",
      padding: "15px 20px"
    }
  }
};
